"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorMessage = exports.StyledCreatingText = exports.StyledTextBox = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTextBox = (0, styled_components_1.default)(ui_components_1.TextField) `
  .MuiInputBase-root {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: ${({ theme }) => theme.spacing(0.5)};

    .text-box-footer {
      align-self: stretch;
      flex: 1;
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid ${ui_components_1.baseColors.background100};
      padding-top: ${({ theme }) => theme.spacing(0.5)};

      .MuiButtonBase-root svg {
        color: ${({ theme, value }) => (value ? theme.palette.primary.main : theme.palette.grey[400])};
        fill: none;
      }

      .Mui-disabled svg {
        cursor: default;
        color: ${({ theme }) => theme.palette.grey[200]};
      }
    }
  }
`;
exports.StyledCreatingText = (0, styled_components_1.default)(ui_components_1.Typography) `
  align-items: center;
  display: flex;
  line-height: 34px;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledErrorMessage = (0, styled_components_1.default)(ui_components_1.Typography) `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${ui_components_1.baseColors.darkRed};
  line-height: 1.67;

  svg {
    font-size: inherit;
    fill: none;
  }
`;
